const memoLast = <K, V>(make: (key: K) => V): ((key: K) => V) => {
	const cache = new Map<K, V>()

	return key => {
		if (cache.has(key)) return cache.get(key) as V

		const value = make(key)
		cache.clear()
		cache.set(key, value)

		return value
	}
}

export { memoLast }
